import { Backdrop, CircularProgress } from "@mui/material";
import { SpinnerComponent } from "@zenith/components";

import { useLoadingContext } from "@zenith/context";

//#region Interfaces

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface LoadingSpinnerWithBackdropProps {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface NotificationProps {}

//#endregion Interfaces

//#region Utils

/**
 * Shows a backdrop with a loading spinner.
 * @param props The props needed for the component to work properly.
 * @returns A react element (backdrop with a loading spinner).
 */
export const LoadingSpinnerWithBackdrop = ({
  isloading,
}: {
  isloading?: boolean;
}) => {
  const {
    loadingContext: { loading },
  } = useLoadingContext();

  return (
    <Backdrop
      sx={{
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        color: "rgb(209, 50, 38)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={loading || !!isloading}
    >
      {isloading ? (
        <SpinnerComponent type="secondary" size={64} showIcon />
      ) : (
        <CircularProgress color="inherit" />
      )}
    </Backdrop>
  );
};

/**
 * Gives you the correct phone number length depending on the country.
 * @param {string} countryCode
 * @param {string} phoneNumber
 */

export const getPhoneNumberLength = (
  countryCode: string,
  phoneNumber: string
) => {
  switch (countryCode) {
    case "GH":
      return 9;
    case "NG":
    default:
      return 10;
  }
};

//#endregion Utils
